export default __webpack_public_path__ + "static/media/f1.6e456677.jpg";